import React, {useState} from 'react';
import { useQuery } from '@apollo/client';
import { TESTIMONIALS } from './queries';
import styled from 'styled-components';
import * as Colors from '../../styles/colors';
import Card from './Card';
import {
  TestimonialsContainer,
  TestimonialGridContainer,
  RegularText
} from './elements';
import { SectionHeader, RedSeparator } from '../Headers/elements';

const Testimonials = () => {
  const { data } = useQuery(TESTIMONIALS);

  return (
    <TestimonialsContainer>
      <SectionHeader>What People Say</SectionHeader>
      <RedSeparator />
      <RegularText>
        Here's what some of our customers have to say about us
      </RegularText>
      <TestimonialGridContainer>
        {data?.testimonials?.map(testimonial => {
          return <Card testimonial={testimonial} key={`t-${testimonial.id}`} />
        })}
      </TestimonialGridContainer>
    </TestimonialsContainer>
  )
}

export default Testimonials;